/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { motion } from 'framer-motion';
import BoxedContainer from './layouts/BoxedContainer';
import getFileSize from '../helpers/get-file-size';
import DownloadableItem from './layouts/DownloadableItem';

function FreeZoneGuideDownloads({ id, data }) {
  const title = _.get(data, 'title', '');
  const text = _.get(data, 'text', '');
  const downloadItems = _.get(data, 'downloadItems', []);
  const bgColor = `#${_.get(data, 'bgColor', 'ffffff')}`;
  const [items, setItems] = useState([]);
  const cTAClassName = _.get(data, 'cTAClassName', '');

  const resolveFileSize = async () => {
    const mapped = await Promise.all(
      _.map(downloadItems, async (item) => {
        // const fileUrl = _.get(item, 'content.file.url', '');
        // const fileSize = await getFileSize(fileUrl);
        // _.set(item, 'content.file.size', fileSize);
        const fileSize = _.get(item, 'content.fileSize', '');
        _.set(item, 'content.fileSize', fileSize);
        return item;
      }),
    );

    setItems(mapped);
  };

  useEffect(() => {
    resolveFileSize();
  }, []);

  return (
    <section id={id} className="relative" style={{ background: bgColor }}>
      <BoxedContainer>
        <div className="w-full py-[43px] md:py-16 lg:py-20 xl:py-25 flex flex-col items-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col items-center gap-y-5 md:gap-y-[30px]">
            {title && (
              <div
                className="child:text-clamp20to40 child:ltr:!font-URWDINMedium 
                child:rtl:!font-GESSTwoDWTCMedium child:leading-[1.3]
                last:child:!m-0 child:text-center child:text-[#231F20]"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            <div className="py-px bg-red w-10 lg:w-12.5" />
            {text && (
              <div
              dangerouslySetInnerHTML={{ __html: text }}
              className="p-child:text-[#4A4A4A] p-child:text-clamp12to18 p-child:font-normal
                p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular 
                p-child:rtl:font-GESSTwoDWTCLight
                text-center"
            />
            )}
          </motion.div>
          <div className="w-full grid grid-cols-12 gap-3 lg:gap-7.5 mt-9 lg:mt-12.5">
            {_.map(items, (item, key) => (
              <div
                className={`col-span-12 md:col-span-6 lg:col-span-4 px-4 py-5 md:p-5 flex gap-3
                lg:gap-[25px] border border-[#ccc]
                ${bgColor==="#ffffff"?'bg-ghostWhite':'bg-white'}`}>
                <DownloadableItem 
                type={cTAClassName !== null ? cTAClassName : 'guide'} index={key} data={item} />
              </div>
            ))}
          </div>
        </div>
      </BoxedContainer>
    </section>
  );
}

export default FreeZoneGuideDownloads;
